import InvestEditTpSlForm from './InvestEditTpSlForm';

export default InvestEditTpSlForm;
